
import Vue from 'vue';
import Component from 'vue-class-component';
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import SectionRequirementHeading from "@/features/applications/components/SectionRequirementHeading.vue";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
import {
    factory,
    PaymentConfirmationRequest, ResultError,
} from "@/api-client";
import {Prop} from "vue-property-decorator";
import {PaymentMethodOption} from "@/features/applications/components/requirements/stateFee/PaymentMethodOption";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";

    @Component({
        components: {
            HeadingWave,
            SectionRequirementHeading,
            HeadingGroup,
            LabelOptional
        },
    })
    export default class PaymentConfirmationForm extends Vue {
    @Prop({default: () => ResultError.createEmpty()})
    errors!: ResultError;
        
    @Prop({required: true})
    confirmPaymentAction!: (paymentConfirmation: PaymentConfirmationRequest) => Promise<void>;

    @Prop({required: true})
    paymentMethodOptions!: PaymentMethodOption[];

    paymentConfirmationRequest: PaymentConfirmationRequest = factory.create(PaymentConfirmationRequest);

    async handleConfirm() {
        await this.confirmPaymentAction(this.paymentConfirmationRequest);
    }

    get isExemptFromPayment(): boolean {
        return this.paymentConfirmationRequest.method === 'Exemption'
    }
}
